import { render, staticRenderFns } from "./PercentageChangeIndicator.vue?vue&type=template&id=406e727c"
import script from "./PercentageChangeIndicator.vue?vue&type=script&lang=js"
export * from "./PercentageChangeIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports